import $ from 'jquery';

import DropDown from 'semantic-ui-dropdown';
import Dimmer from 'semantic-ui-dimmer';
import Transition from 'semantic-ui-transition';
import Checkbox from 'semantic-ui-checkbox';
import Modal from 'semantic-ui-modal';

$.fn.extend({
    dropdown: DropDown,
    dimmer: Dimmer,
    transition: Transition,
    checkbox: Checkbox,
    modal: Modal,
});

export default $;
